import styled from 'styled-components';

import { Button } from '@xingternal/button';

export const StyledBookmarkActionContainer = styled(Button)<{ $isWideButton: boolean }>`
  padding: ${({ $isWideButton }) => ($isWideButton ? '10px' : 0)};
  width: ${({ $isWideButton }) => ($isWideButton ? '50%' : 0)};
`;
